import { render, staticRenderFns } from "./auth-role.vue?vue&type=template&id=2e69d0ae&scoped=true"
import script from "./auth-role.vue?vue&type=script&lang=js"
export * from "./auth-role.vue?vue&type=script&lang=js"
import style0 from "./auth-role.vue?vue&type=style&index=0&id=2e69d0ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69d0ae",
  null
  
)

export default component.exports